// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import qs from "qs";

export interface ExportToCsvApiParameter extends ApiParameter {
    id: string;
    email: string;
    pageType: string;
}

const exportToCsvUrl = "api/mcmc/ExportProducts";

export function exportListToCsv(parameter: ExportToCsvApiParameter) {
    const combinationQueryString = `${exportToCsvUrl}/${parameter.pageType}`;
    return post(`${combinationQueryString}?id=${parameter.id}&email=${parameter.email}`);
}

export function exportOrderHistoryToCsv(parameter: GetOrdersApiParameter) {
    const queryString = qs.stringify(parameter);
    return post(`api/mcmc/ordersExport${queryString !== "" ? `?${queryString}` : ""}`);
}

export function exportInvoiceHistoryToCsv(parameter: GetInvoicesApiParameter) {
    const queryString = qs.stringify(parameter);
    return post(`api/mcmc/invoicesExport${queryString !== "" ? `?${queryString}` : ""}`);
}
